import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BaseEntityService } from './baseentity-service';
import { Http, Response} from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CONFIRMACION_VALUES } from './negocios-service';
import {
  PATH_NEW_PRECIO,
  PATH_NEW_PRECIO_PIZARRA,
  PATH_ABM,
  PATH_ABM_ROL_DETAIL,
  PATH_ABM_NUEVO_ROL,
  PATH_ABM_ACOPIO_DETAIL,
  PATH_ABM_CATEGORIA_DETAIL,
  PATH_VALIDATE_PRECIO,
  PATH_VALIDATE_PIZARRA,
  PATH_PERMISO_DETAIL,
  PATH_ACTIVIDAD,
  PATH_COMUNICACION_DETAIL,
  PATH_NEGOCIOS,
  PATH_AGRIS_HOME,
  PATH_NEW_PRECIO_FINANCIERA,
  PATH_ADMINISTRACION, PATH_EDITAR_USUARIO_AGRO, PATH_DETALLE_USUARIO_AGRO,
  PATH_AGRIS_COTIZACION_DETALLE,
  PATH_AGRIS_NUEVA_COTIZACION,
  PATH_AGRIS_DETALLE_INSUMO,
  PATH_AGRIS_BUSCADOR,
  PATH_AGRIS_COTIZACION_LISTA,
  PATH_COMUNICADOS,
} from '../navigation/navigation.module';
import { Router } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { NotificationSnackbarComponent } from '../components/common/snackbar/notification-snackbar/notification-snackbar.component';
import { Subject } from 'rxjs/Subject';

export const PERM_ACCIONES_ID = {
  P_ABM: 1,
  P_Actividad: 2,
  P_Actividad_Todos: 3,
  A_CrearNegocio:	4,
  A_EditarNegocio: 5,
  A_AnularNegocio: 6,
  A_DuplicarNegocio: 7,
  A_CambiarNegocioTipo:	8,
  A_LlamarCliente: 9,
  A_ConfirmarNegocio:	10,
  A_ConsultarMesa: 11,
  A_AutorNoAutor:	12,
  A_RechazarPrEspecial:	13,
  P_Precios: 14,
  P_CrearPrecio: 15,
  A_CrearPrecio_CrearPosicion:	16,
  P_ValidarPrecio: 17,
  P_PreciosPizarra:	18,
  P_CrearPrecioPizarra:	19,
  P_ValidarPrecioPizarra:	20,
  P_Actividad_Comunicados: 21,
  A_EditarContacto:	22,
  A_EliminarContacto: 23,
  A_EditarEmpr: 24,
  A_EliminarEmprProsp: 25,
  A_CrearComunicado: 26,
  A_EditarComunicado: 27,
  A_DuplicarComunicado: 28,
  A_EliminarComunicado: 29,
  A_VerColabComunicado: 30,
  A_AnularNegocioConfirmado: 31,
  A_CrearPrecioEspecial: 32,
  P_Administracion: 33,
  P_Administracion_Dolarizacion: 34,
  A_AutorNoAutorNegOlvidado: 35,
  P_Financiera: 36,
  A_CrearPrecioFinanciera: 37,
  A_ValidarPrecioFinanciera: 38,
  P_Agris: 39,
  P_Usuario_Agro: 40,
  A_EditarProsp: 41,
  A_Autorizacion_Dolarizacion: 43,
  A_EditarNomUsuario: 45,
  A_Admin_Agris: 46,
  P_Remito: 47,
  A_Admin_Remito: 48,
  P_Logistica: 49,
  A_Admin_Logistica: 50,
  P_Indicadores: 51,
  A_Aprobar_Editar_PlanComercial: 52,
  P_Indicadores_Dashboard: 53,
  P_Indicadores_Avances: 54,
  P_Saf_Creditos: 60,
  P_BANNERS: 61,
  P_Indicadores_evolutivo_radar: 101,
};

export const NEG_ACTIONS = {
  CONSULTAR: 'consultar',
  DUPLICAR: 'duplicar',
  ANULAR: 'anular',
  EDITAR: 'editar',
  CAMBIAR_TIPO: 'swap',
  CREAR: 'crear',
  AUTORIZAR_NOAUTORIZAR: 'autorizar',
  AUTORIZAR_NOAUTORIZAR_OLVIDADO: 'autorizarOlv'
};

@Injectable()
export class PermisosService extends BaseEntityService {
  constructor(httpClient: HttpClient,
              private http: Http,
              private router: Router,
              private snackBar: MdSnackBar) {
    super(httpClient);
  }

  apiRoute: string = '/api/permiso/get-acciones';

  actionsToEdit = new BehaviorSubject<any[]>([]);

  private permisos: any[] = null;

  private paths = [
    {path: PATH_NEW_PRECIO,             permisoId: PERM_ACCIONES_ID.P_CrearPrecio},
    {path: PATH_NEW_PRECIO_PIZARRA,     permisoId: PERM_ACCIONES_ID.P_CrearPrecioPizarra},
    {path: PATH_ABM,                    permisoId: PERM_ACCIONES_ID.P_ABM},
    {path: PATH_ABM_ROL_DETAIL,         permisoId: PERM_ACCIONES_ID.P_ABM},
    {path: PATH_ABM_NUEVO_ROL,          permisoId: PERM_ACCIONES_ID.P_ABM},
    {path: PATH_ABM_ACOPIO_DETAIL,      permisoId: PERM_ACCIONES_ID.P_ABM},
    {path: PATH_ABM_CATEGORIA_DETAIL,   permisoId: PERM_ACCIONES_ID.P_ABM},
    {path: PATH_VALIDATE_PRECIO,        permisoId: PERM_ACCIONES_ID.P_ValidarPrecio},
    {path: PATH_VALIDATE_PIZARRA,       permisoId: PERM_ACCIONES_ID.P_ValidarPrecioPizarra},
    {path: PATH_PERMISO_DETAIL,         permisoId: PERM_ACCIONES_ID.P_ABM},
    {path: PATH_ACTIVIDAD,              permisoId: PERM_ACCIONES_ID.P_Actividad},
    {path: PATH_COMUNICACION_DETAIL,    permisoId: PERM_ACCIONES_ID.P_Actividad_Comunicados},
    {path: PATH_NEW_PRECIO_FINANCIERA,  permisoId: PERM_ACCIONES_ID.A_CrearPrecioFinanciera},
	{path: PATH_ADMINISTRACION,         permisoId: PERM_ACCIONES_ID.P_Administracion},
    {path: PATH_EDITAR_USUARIO_AGRO,    permisoId: PERM_ACCIONES_ID.P_Usuario_Agro},
    {path: PATH_DETALLE_USUARIO_AGRO,   permisoId: PERM_ACCIONES_ID.P_Usuario_Agro},
    {path: PATH_AGRIS_HOME,             permisoId: PERM_ACCIONES_ID.P_Agris},
    {path: PATH_AGRIS_COTIZACION_DETALLE,permisoId: PERM_ACCIONES_ID.P_Agris},
    {path: PATH_AGRIS_NUEVA_COTIZACION, permisoId: PERM_ACCIONES_ID.P_Agris},
    {path: PATH_AGRIS_DETALLE_INSUMO,   permisoId: PERM_ACCIONES_ID.P_Agris},
    {path: PATH_AGRIS_BUSCADOR,         permisoId: PERM_ACCIONES_ID.P_Agris},
    {path: PATH_AGRIS_COTIZACION_LISTA, permisoId: PERM_ACCIONES_ID.P_Agris},
    {path: PATH_COMUNICADOS,            permisoId: PERM_ACCIONES_ID.P_Actividad_Comunicados},
  ];

  private storageItemError = new Subject<boolean>();

  responseItemToEntity(responseItem: any): any {
    return {
      Id: responseItem.AccionId,
      ParentId: responseItem.AccionParentID,
      Descripcion: responseItem.Descripcion,
      Nombre: responseItem.Nombre
    };
  }

  public setActionsToEdit(actionsId: number[]) {
    // en caso que se intente llenar los valores y aun las acciones no se cargaron, nos suscribimos para cargar las acciones a editar ni bien lleguen
    if (this.Options.getValue().length) {
      this.setSelectedActions(actionsId);
    } else {
      this.Options.subscribe(x => {
        this.setSelectedActions(actionsId);
        this.Options.unsubscribe();
      });
    }
  }

  private setSelectedActions(actionsId: number[]) {
    const copy = this.Options.getValue();
    copy.forEach(x => {
      x['selected'] = actionsId.indexOf(x.Id) > -1;
    });
    this.actionsToEdit.next(copy);
  }

  // con este void obtenemos los Child para mostrar en un Action Component e incluimos los child de child para sucesivas herencias
  public getDirectChilds(id) {
    const childs = this.actionsToEdit.getValue();
    childs.forEach(x => {
      x.checked = false;
    });
    // primero obtenemos los Child Directos
    const directChilds = childs.filter(x => x.ParentId === id);
    const indirectChilds = [];
    // luego iteramos entre los childs para obtener el arbol de childs indirectos
    directChilds.forEach(x => {
      // agregamos los "nietos" a los child indirectos
      indirectChilds.push(...childs.filter(y => y.ParentId === x.Id));
    });
    // finalmente revisamos recursivamente los nietos
    while (indirectChilds.filter(x => x.checked === false).length) {
      // generamos una copia por si cambia el tamaño del array mientras se itera
      let copy = [...indirectChilds.filter(x => !x.checked)];
      copy.forEach(x => {
        // por cada item buscamos un child, si existe, lo agregamos a la lista de childs y marcamos el item buscado como checked
        // como no sabemos el index del item en el array original, lo buscamos
        indirectChilds[indirectChilds.findIndex(y => y.Id === x.Id)].checked = true;
        indirectChilds.push(...childs.filter(y => y.ParentId === x.Id));
      });
    }

    directChilds.forEach(x => delete x.checked);
    indirectChilds.forEach(x => delete x.checked);
    // direct Childs = hijos, IndirectChilds = nietos, bisniteos, y asi hasta infinitos tataranietos
    return {DirectChilds: directChilds, IndirectChilds: indirectChilds};
  }

  public onActionChanged(actionId, newState) {
    // aca generamos los cambios para las acciones que dependen de un cambio en una accion especifica
    // primero generamos una copia de nuestro arbol de permisos actual para editarla y seteamos el valor que cambió
    const copy = this.actionsToEdit.getValue();
    copy[copy.findIndex(x => x.Id === actionId)].selected = newState;
    let idsToChange = [];
    // si estamos desactivando un permiso, desactivamos todos sus hijos
    if (!newState) {
      const childs = this.getDirectChilds(actionId);
      idsToChange = [...childs.DirectChilds, ...childs.IndirectChilds].map(y => y.Id);
    } else {
      // si estamos habilitando un permiso, habilitamos todos sus parent directos
      let currentAction = actionId;
      let currentParentId = copy[copy.findIndex(x => x.Id === currentAction)].ParentId;
      while (currentParentId !== null) {
        idsToChange.push(currentParentId);
        currentAction = currentParentId;
        currentParentId = copy[copy.findIndex(x => x.Id === currentAction)].ParentId;
      }
    }
    copy.forEach(x => {
      if (idsToChange.includes(x.Id)) {
        x.selected = newState;
      }
    });
    this.actionsToEdit.next(copy);
  }

  getAllPermisos() {
    return this.httpClient.get(`/api/permiso/get-all`)
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  createPermiso(productosIds: number[], nombre: string, descripcion: string) {
    const payload = {
      Productos: productosIds,
      Descripcion: descripcion,
      Acciones: this.actionsToEdit.getValue().filter(x => x.selected).map(x => x.Id),
      Nombre: nombre
    };
    return this.httpClient.post(`/api/permiso`, payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getPermisoById(id) {
    return this.httpClient.get(`/api/permiso/${id}`)
      .map((response: Response) => {
        if (response) {
          return response.json().ResponseData;
        }
      });
  }

  updatePermiso(idPermiso: number, productosIds: number[], nombre: string, descripcion: string) {
    const payload = {
      PermisoId: idPermiso,
      Productos: productosIds,
      Descripcion: descripcion,
      Acciones: this.actionsToEdit.getValue().filter(x => x.selected).map(x => x.Id),
      Nombre: nombre
    };
    return this.httpClient.put(`/api/permiso`, payload)
      .map((response: Response) => {
        return response.json();
      });
  }

  // con esta funcion, devolvemos si se está autorizado a utilizar un permiso o no
  permisoAutorizado(permisoId) {
    this.cargarPermisosLocales();
    if (!this.permisos || !this.permisos.length) {
      return false;
    }
    return permisoId ? this.permisos.indexOf(permisoId) > -1 : false;
  }

  // devolvemos un array de strings que contienen la estructura de tabs segun los permisos
  tabsPermitidas(tabs: string[], idPermisos: number[], relacion: string[]) {
    this.cargarPermisosLocales();
    /**devolvemos el array restando los permisos
     * tabs: array de tabs original
     * IdPermisos: array de Ids de permisos a checkear
     * relacion: array de nombres de los permisos iguales a los presentes en el array inicial pero en orden de los ID
     * EJ: [tab1, tab2, tab3, tab4, tab5], [permisoIdTab3, permisoIdTab5], [tab3, tab5]
     * **/
    idPermisos.forEach((x, i) => {
      if (this.permisos.indexOf(x) < 0) {
        tabs.splice(tabs.indexOf(relacion[i]), 1);
      }
    });
    return tabs;
  }

  cargarPermisosLocales() {
    if (this.permisos === null || !this.permisos.length) {
      // generamos el array de permisos como un number
      const permisosArray = localStorage.getItem('accionesId');
      // nos cubrimos en caso de que se ingrese por URL y no haya cookies de permisos en el dispositivo
      if (permisosArray) {
        this.permisos = permisosArray.split(',').map(x => Number(x));
      } else {
        this.storageItemError.next(true);
      }
    }
  }

  verificarAccesoDeURL() {
    const splitURL = this.router.url.substr(1).split('/');
    const indexFound = this.paths.findIndex(x => x.path === splitURL[0]);
    if (indexFound > -1) {
      if (!this.permisoAutorizado(this.paths[indexFound].permisoId)) {
        this.router.navigate([PATH_NEGOCIOS]);
        this.mostrarSnackbarAdvertencia();
      }
    }
  }

  public mostrarSnackbarAdvertencia() {
    this.snackBar.openFromComponent(NotificationSnackbarComponent, {
      duration: 5000,
      data: 'Lo sentimos, usted no posee acceso a esta sección.',
      extraClasses: ['agd-warning-snackbar']
    });
  }

  /** ----- Permisos de Negocios ----- **/

  public showNegocioAction(action, estado = null, tipo = null) {
    this.cargarPermisosLocales();
    switch (action) {
      case NEG_ACTIONS.CONSULTAR:
        return true;
      case NEG_ACTIONS.EDITAR:
        if (this.permisoAutorizado(PERM_ACCIONES_ID.A_EditarNegocio) && this.negocioChangesAllowed(estado) &&
          // no se pueden editar negocios confirmados ni anulados
          !(estado === CONFIRMACION_VALUES.CONFIRMADA || estado === CONFIRMACION_VALUES.ANULADA)) {
          // autorizante puede editar matcheados y en proceso (AAUF-981), confirmado ya no se puede editar (AAUF-1197)
          // ACTUALIZACION: Ante el nuevo sistema de roles, quienes posean el permiso N12: Autorizar, No Autorizar, tendran este privilegio.
          if (this.permisoAutorizado(PERM_ACCIONES_ID.A_AutorNoAutor) && (estado === CONFIRMACION_VALUES.MATCHEADA || estado === CONFIRMACION_VALUES.EN_PROCESO) ||
              // Si no se cumple la condicion anterior, los siguientes estados son editables teniendo en cuenta que en este punto el usuario posee permiso de editar negocios
              (estado === CONFIRMACION_VALUES.ACTIVA ||
              estado === CONFIRMACION_VALUES.MATCHEADA ||
              estado === CONFIRMACION_VALUES.NO_AUTORIZADA ||
              estado === CONFIRMACION_VALUES.VENCIDA)) {
            return true;
          }
        }
        return false;
      case NEG_ACTIONS.DUPLICAR:
        return this.permisoAutorizado(PERM_ACCIONES_ID.A_CambiarNegocioTipo) && (estado === CONFIRMACION_VALUES.ACTIVA || estado === CONFIRMACION_VALUES.NO_AUTORIZADA);
      case NEG_ACTIONS.CAMBIAR_TIPO:
        // tipo 6 = negocio olvidado, no se puede cambiar el tipo a este tipo de negocio
        return this.permisoAutorizado(PERM_ACCIONES_ID.A_CambiarNegocioTipo) && (estado === CONFIRMACION_VALUES.ACTIVA || estado === CONFIRMACION_VALUES.NO_AUTORIZADA) && tipo !== 6;
      case NEG_ACTIONS.ANULAR:
        return ((this.permisoAutorizado(PERM_ACCIONES_ID.A_AnularNegocio) &&
          (estado === CONFIRMACION_VALUES.ACTIVA ||
          estado === CONFIRMACION_VALUES.NO_AUTORIZADA ||
          estado === CONFIRMACION_VALUES.MATCHEADA ||
          estado === CONFIRMACION_VALUES.EN_PROCESO)) ||
          (this.permisoAutorizado(PERM_ACCIONES_ID.A_AnularNegocioConfirmado) && estado === CONFIRMACION_VALUES.CONFIRMADA));
      case NEG_ACTIONS.CREAR:
        return this.permisoAutorizado(PERM_ACCIONES_ID.A_CrearNegocio);
      case NEG_ACTIONS.AUTORIZAR_NOAUTORIZAR:
        return (estado === CONFIRMACION_VALUES.ACTIVA || estado === CONFIRMACION_VALUES.MATCHEADA || estado === CONFIRMACION_VALUES.EN_PROCESO) &&
          this.permisoAutorizado(PERM_ACCIONES_ID.A_AutorNoAutor);
      case NEG_ACTIONS.AUTORIZAR_NOAUTORIZAR_OLVIDADO:
        return estado === CONFIRMACION_VALUES.EN_PROCESO && this.permisoAutorizado(PERM_ACCIONES_ID.A_AutorNoAutorNegOlvidado);
    }
    return false;
  }

  private negocioChangesAllowed(estado) {
    return !(estado === CONFIRMACION_VALUES.FINALIZADO ||
    estado === CONFIRMACION_VALUES.AVISO_GENERADO ||
    estado === CONFIRMACION_VALUES.GENERACION_AVISO ||
    estado === CONFIRMACION_VALUES.AVISO_CANCELADO);
  }

  limpiarPermisos() {
    this.permisos = null;
  }

  localStorageError() {
    return this.storageItemError.asObservable();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/permisos-service.ts